const carInfoObject = {
  C: "소형",
  D: "중형",
  E: "대형",
  SUV: "SUV",
  ev: "전기",
  gasoline: "가솔린",
};

export default carInfoObject;
